import { fsService } from '@services/firebase/firestore/firestore';
import { collectionRef, Config } from '@vincerosoft/assessfluence-types';

function tenantFactory() {
  async function getTenantConfig() {
    const configDocs = await fsService.getDocs<Config['app_settings'] | Config['account']>(
      collectionRef.tenantConfig
    );

    const tenantConfig: {
      appSettings: Config['app_settings'] | null;
      adminAccount: Config['account'] | null;
    } = {
      appSettings: null,
      adminAccount: null
    };

    configDocs.forEach((doc) => {
      if (doc.id === 'app_settings') {
        const systemAppConfig = doc as unknown as Config['app_settings'];
        tenantConfig.appSettings = systemAppConfig;
      }
      if (doc.id === 'account') {
        const accountSettings = doc as Config['account'];
        tenantConfig.adminAccount = accountSettings;
      }
    });

    return tenantConfig;
  }

  return {
    getTenantConfig
  };
}

export const tenantService = tenantFactory();
